<script>

    import NumeralMethods from '../$methods/numeral.methods'

    export let rows = []
    export let partner = ''

    $: fedex = partner === 'FedEx'
    $: showReal = partner === 'FedEx' || partner === 't1envios'
    $: showKilos = partner !== 'skydropx'

</script>

<div class="table-wrap">
    <table class="table is-fullwidth is-narrow">
        <thead>
            <tr>
                <th>#</th>
                <th>Guía</th>
                <th>Usuario</th>
                <th>Declarado</th>
                {#if showReal}
                    <th>Real</th>
                {/if}
                {#if showKilos}
                    <th>Kilos</th>
                {/if}
                <th>Costo envío</th>
                {#if fedex}
                    <th>Monto</th>
                {/if}
                <th>Excedente</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            {#each rows as row}
                <tr class:has-cost={ row.charge } class:is-missing={ !row.found }>
                    <td>{ row.line }</td>
                    <td>{ row.guide || '-' }</td>
                    <td>{ row.user || '-' }</td>
                    <td>{ row.declared ?? '-' }</td>
                    {#if showReal}
                        <td>{ row.weight ?? '-' }</td>
                    {/if}
                    {#if showKilos}
                        <td>{ row.kilos ?? '-' }</td>
                    {/if}
                    <td>{ row.found ? NumeralMethods.cash(row.shipmentCost) : '-' }</td>
                    {#if fedex}
                        <td>{ NumeralMethods.cash(row.invoiceTotal) }</td>
                    {/if}
                    <td>{ fedex ? (row.found ? NumeralMethods.cash(row.excess) : '-') : NumeralMethods.cash(row.excess ?? row.invoiceTotal) }</td>
                    <td>
                        {#if row.review}
                            <span class="tag is-danger is-light">En revisión</span>
                        {/if}
                        {#if !row.found}
                            <span class="tag is-danger is-light">No encontrada</span>
                        {:else if row.note}
                            <span class="tag is-light">{ row.note }</span>
                        {:else}
                            <span class="tag" class:is-warning={ row.charge } class:is-light={ !row.charge }>
                                { row.charge ? 'Con costo' : 'Sin costo' }
                            </span>
                        {/if}
                    </td>
                </tr>
            {/each}
        </tbody>
    </table>
</div>

<style>
    .table-wrap {
        overflow: auto;
        margin-bottom: 0.75rem;
    }

    thead th {
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 1;
    }

    tr.has-cost {
        background: #fff6e0;
    }

    tr.is-missing {
        background: #fdecec;
    }
</style>
